import { Component } from './component';

interface ProgressIndicatorProps {
  value?: number;
  segmented?: boolean;
}

export class ProgressIndicator extends Component {
  public el: HTMLDivElement;
  private bar: HTMLSpanElement;
  private value = 0;

  constructor(props?: ProgressIndicatorProps) {
    super();
    this.el = document.createElement('div');
    this.el.classList.add('progress-indicator');

    if (props?.segmented) {
      this.el.classList.add('segmented');
    }

    this.bar = document.createElement('span');
    this.bar.classList.add('progress-indicator-bar');

    if (props?.value !== undefined) {
      this.setValue(props.value);
    }

    this.el.appendChild(this.bar);
  }

  private clampValue(value: number): number {
    return Math.max(0, Math.min(100, value));
  }

  setValue(value: number) {
    this.value = this.clampValue(value);
    this.bar.style.width = `${this.value}%`;
  }

  getValue(): number {
    return this.value;
  }
}
